import i18n from 'i18next';
import { string, ref } from 'yup';
import { phoneRegExp, emailRegExp, passwordRegExp } from 'globalutils/constants';
import { ROLES } from 'globalconfig/constants/keys';

export const schemaTenant = {
  [ROLES.WEBFLEET]: {},
  default: {
    userPhone: string().matches(phoneRegExp, i18n.t('common.validNumFormat')).required(i18n.t('common.fieldRequiredMessage')),
  },
};

export const commonSchema = {
  password: string()
    .nullable()
    .matches(passwordRegExp, i18n.t('common.passwordValidMessage'))
    .required(i18n.t('common.fieldRequiredMessage')),
  confirmPassword: string()
    .nullable()
    .oneOf([ref('password'), null], i18n.t('common.confirmPasswordMessage'))
    .required(i18n.t('common.fieldRequiredMessage')),
};

export const editSchema = {
  ...commonSchema,
  firstName: string().required(i18n.t('common.fieldRequiredMessage')),
  lastName: string().required(i18n.t('common.fieldRequiredMessage')),
  ...(schemaTenant[window.$environment.SERVICE_PROVIDER] || schemaTenant.default),
  email: string().matches(emailRegExp, i18n.t('common.emailValidationMessage')).required(i18n.t('common.fieldRequiredMessage')),
};
